import React from 'react'
import _ from 'lodash'

import { parseToReactElement } from '../../../utils/html'
import BasicModal from './BasicModal'
import { withContent } from '../../../utils/hocs'

import './ActivateLicensesModal.css'

const ActivateLicensesModal = ({ content, isOpen, onClose }) => (
  <BasicModal
    header={_.get(content, 'coupons.modal_activatelicenses_header')}
    body={parseToReactElement(_.get(content, 'coupons.modal_activatelicenses_body'), null, { ADD_ATTR: ['target'] })}
    button={_.get(content, 'coupons.modal_activatelicenses_button')}
    isOpen={isOpen}
    onClose={onClose}
  />
)

export default withContent(ActivateLicensesModal)
